'use strict';

var index = require('../../../../../index-B_8xeRkv.js');

"use strict";
const pluginVersion = "12.4.2";
const defaultOptions = {
  colorMode: index.BigValueColorMode.Value,
  graphMode: index.BigValueGraphMode.Area,
  justifyMode: index.BigValueJustifyMode.Auto,
  percentChangeColorMode: index.PercentChangeColorMode.Standard,
  showPercentChange: false,
  textMode: index.BigValueTextMode.Auto,
  wideLayout: true
};

exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
